/* ==========================================================================
   Stories Filter
   ========================================================================== */

// ...

import Isotope from "isotope-layout";

var storyFilterExists = <HTMLInputElement>(
  document.getElementById("story-filters")
);

var noShift = document.querySelectorAll(".stories-grid");
/*
if (storyFilterExists) {
  window.onload = function () {
    var iso = new Isotope("#story-filters", {
      itemSelector: ".story",
      hiddenStyle: {
        opacity: 0,
      },
      visibleStyle: {
        opacity: 1,
      },
    });

    // bind filter button click
    var filtersElem = <HTMLInputElement>(
      document.querySelector(".filters-button-group")
    );
    filtersElem.addEventListener("click", function (event) {
      if (!(event.target instanceof HTMLElement)) {
        return;
      }
      var filterValue = event.target.getAttribute("data-filter");
      if (filterValue != "*") {
        for (var i = 0; i < noShift.length; ++i) {
          noShift[i].classList.add("no-shift");
        }
      } else {
        for (var i = 0; i < noShift.length; ++i) {
          noShift[i].classList.remove("no-shift");
        }
      }

      iso.arrange({ filter: filterValue });
    });
  };
}*/
